
// export const server_base_url = "http://localhost:5000";
export const server_base_url = "https://newbreakapi.ads247365.com/";

let version = `${server_base_url}/api/v1/user`;
let user = `${version}`;
let version1 = `${server_base_url}/api/v1/admin`;
let admin = `${version1}`;

export const api_configs = {
  // ----------------ADMIN------------------ 
  addEmployee: `${admin}/addEmployee`,
  employeeList: `${admin}/employeeList`,
  editEmployee: `${admin}/editEmployee`,
  // getProfile: `${admin}/getProfile`,
  deleteEmployee: `${admin}/deleteEmployee`,
  desigantionList: `${admin}/desigantionList`,
  employeeListtest: `${admin}/employeeListtest`,
  addDesigantion: `${admin}/addDesigantion`,
  attendanceEdit: `${admin}/attendanceEdit`,
  addHoliday: `${admin}/addHoliday`,
  holidayDelete: `${admin}/holidayDelete`,
  desigantionDelete: `${admin}/desigantionDelete`,
  editHoliday: `${admin}/editHoliday`,
  addDocuments: `${admin}/addDocuments`,
  deleteDocuments: `${admin}/deleteDocuments`,
  addPolicies: `${admin}/addPolicies`,
  deletePolicies: `${admin}/deletePolicies`,
  deleteAttendance: `${admin}/deleteAttendance`,
  deleteBreaktime: `${admin}/deleteBreaktime`,
  updateLavesStatus: `${admin}/updateLavesStatus`,
  blockandunblock: `${admin}/blockandunblock`,


  // ----------------USER-------------------
  login: `${user}/login`,
  uploadFile: `${user}/uploadFile`,
  getProfile: `${user}/getProfile`,
  atpunchIn: `${user}/atpunchIn`,
  atpunchOut: `${user}/atpunchOut`,
  punchIn: `${user}/punchIn`,
  punchOut: `${user}/punchOut`,
  employeeBreaktimeList: `${user}/employeeBreaktimeList`,
  employeeAttendanceList: `${user}/employeeAttendanceList`,
  holidayList: `${user}/holidayList`,
  dailyStatus: `${user}/dailyStatus`,
  emptodayList: `${user}/emptodayList`,
  employeeStatus: `${user}/employeeStatus`,
  viewEmployee: `${user}/viewEmployee`,
  policiesList: `${user}/policiesList`,
  applyLeave: `${user}/applyLeave`,
  leaveList: `${user}/leaveList`,
  leaveDelete: `${user}/leaveDelete`,
  update_Leave: `${user}/update_Leave`,
  allleave_requestList: `${user}/allleave_requestList`,
  login_activity: `${user}/login_activity`,
  loginactivirylist: `${user}/loginactivirylist`,
};
